import React from "react"
import { Navigate } from "react-router-dom"

import { Permission } from "constants/permissions"

import { usePermissions } from "../contexts/PermissionsContext"
import { useProps } from "../contexts/PropsContext"

interface ProtectedRouteProps {
  permission: Permission
  children: React.ReactNode
}

export const ProtectedRoute = ({ permission, children }: ProtectedRouteProps) => {
  const { user } = useProps()
  const { has } = usePermissions()

  if (!user || !has(permission)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
